import { X } from 'lucide-react'
import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

interface PremiumBannerProps {
  gameDisplayName: string
}

export function PremiumBanner({ gameDisplayName }: PremiumBannerProps) {
  const navigate = useNavigate()
  const [isDismissed, setIsDismissed] = useState(false)

  // Check localStorage on mount
  useEffect(() => {
    const dismissed = localStorage.getItem('premium-banner-dismissed')
    if (dismissed === 'true') {
      setIsDismissed(true)
    }
  }, [])

  // Handle dismiss
  const handleDismiss = () => {
    setIsDismissed(true)
    localStorage.setItem('premium-banner-dismissed', 'true')
  }

  // Don't render if dismissed
  if (isDismissed) {
    return null
  }

  return (
    <div className="bg-gradient-to-br from-[#C5A572] to-[#B59562] text-white rounded-2xl p-6 mb-8 shadow-lg flex items-center justify-between relative">
      {/* Close button */}
      <button
        onClick={handleDismiss}
        className="absolute top-4 right-4 p-1 rounded-lg hover:bg-white/20 transition-colors"
        aria-label="Dismiss banner"
      >
        <X className="w-5 h-5" />
      </button>

      {/* Content */}
      <div className="flex-1 pr-4">
        <h2 className="text-3xl font-bold uppercase tracking-wide mb-1"
            style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
          Unlock Full Archive Access
        </h2>
        <p className="text-base opacity-95"
           style={{ fontFamily: 'Oswald, sans-serif' }}>
          Premium members get unlimited access to all past {gameDisplayName} challenges
        </p>
      </div>

      {/* CTA Button */}
      <button
        onClick={() => navigate(`/subscription?returnTo=${encodeURIComponent(window.location.pathname + window.location.search)}`)}
        className="bg-white text-[#C5A572] px-8 py-3 rounded-xl font-bold uppercase tracking-wide transition-all hover:-translate-y-1 hover:shadow-xl whitespace-nowrap"
        style={{ fontFamily: 'Oswald, sans-serif' }}
      >
        Upgrade to Premium
      </button>
    </div>
  )
}
